import { NU0 } from '../../../constants/math';

const { sqrt, log, pow, PI, E, log1p, exp } = Math;

// source: IPC-2141A Formula 4-4 (Make sure to check errata)
export function characteristicImpedance(params) {
  const { w, h, e, t } = mapStandardParamsToFormulaParams(params);

  const eEff = effectiveDielectricConstant(e, w, h);
  const wEff = w
    + (t / PI)
    * log(4*E/sqrt(pow(t/h, 2) + pow(t/(t/(w*PI + 1.1*t*PI)), 2)))
    * ((eEff + 1) / (2 * eEff));
  const z0 = (NU0/(2 * PI * sqrt(2) * sqrt(eEff + 1)))
    * log1p(
      (4*h/wEff) 
      * (
        (4*h/wEff) 
        * ((14*eEff + 8)/(11*eEff))
        + sqrt(16* pow(h/wEff, 2) * pow((14*eEff + 8)/(11*eEff),2) + ((eEff + 1)/(2*eEff))*pow(PI, 2))
      )
    );

  return z0;
}

// Source: unknown
export function differentialImpedance(params) {
  const { s, h } = mapStandardParamsToFormulaParams(params);
  const z0 = characteristicImpedance(params);

  const zDiff = 2 * z0 * (1 - 0.48 * exp(-0.96 * s/h));
  return zDiff;
}

// source: unknown
export function propagationalDelay(params) {
  const { w, h, e, t } = mapStandardParamsToFormulaParams(params);

  const eEff = effectiveDielectricConstant(e, w, h);
  const tPd = 84.72 * sqrt(eEff - ((e-1) * (t/h)/(4.6 * sqrt(w/h))));

  return tPd;
}

export function mapStandardParamsToFormulaParams(params) {
  const {
    // dielectricUpHeight, // This always should be 0;
    dielectricDownHeight,
    dk,
    thickness,
    transmissionSpacing,
    transmissionWidth
  } = params;

  return {
    w: transmissionWidth,
    h: dielectricDownHeight,
    e: dk,
    t: thickness,
    s: transmissionSpacing,
  }
}

export function effectiveDielectricConstant(e, w, h) {
  const eEff = w/h < 1 
    ? (e+1)/2 + (e-1)/2 * (1/sqrt(1+12*(h/w)) + 0.04*pow((1-w/h), 2))
    : (e+1)/2 + (e-1)/(2 * sqrt(1+12*(h/w)))
  ;

  return eEff;
}

export default {
  characteristicImpedance,
  differentialImpedance,
  propagationalDelay,
}


// WEBPACK FOOTER //
// ./src/lib/simulations/formulas/microstrip.js